export const TranslationsSQ = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        sk: 'Slovenčina',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
        zht: '繁體中文',
        he: 'עברית',
        sq: 'Shqip',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        sk: 'SK',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: 'ZHT',
        he: 'HE',
        sq: 'SQ',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        sk: 'SLK',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
        zht: '繁體',
        he: 'HEB',
        sq: 'SQI',
    },
    // BASE
    phrases: {
        order_online: 'Porosit Online',
        cart: 'Shporta',
        open_24: '24 Orë',
        closed: 'Mbyllur',
        free: 'FALAS',
        something_went_wrong: 'diçka shkoi keq',
        try_again: 'provo përsëri',
    },
    constants: {
        calendar: {
            days: {
                monday: 'E hënë',
                tuesday: 'E martë',
                wednesday: 'E mërkurë',
                thursday: 'E enjte',
                friday: 'E premte',
                saturday: 'E shtunë',
                sunday: 'E diel',
            },
        },
        services: {
            pickup: 'Marrje',
            delivery: 'Dërgesë',
            dine_in: 'Në vend',
            table_booking: 'Rezervim Tavoline',
        },
        payment: {
            method: {
                cash: 'Para në dorë',
                card: 'Kartë',
                stripe: 'Kartë Krediti',
                paypal: 'PayPal',
                cardconnect: 'Kartë Krediti',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net',
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Para në dorë',
                card: 'Kartë',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online',
            },
            status: {
                success: 'Sukses',
                pending: 'Në Pritje',
                error: 'Gabim',
                refunded: 'Rimbursuar',
                refunding: 'Duke Rimbursuar',
                partial_refunded: 'Pjesërisht e Rimbursuar',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Hiq',
                drop_here: 'Lini skedarët këtu ose klikoni për të zgjedhur një',
                accepts: 'Pranon skedarë {{fileTypes}}',
                errors: {
                    max_files: 'Maksimumi {{number}} i lejuar',
                    max_size: 'Madhësia maksimale e skedarit {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Dyqani është aktualisht i mbyllur dhe nuk mund të bëhet porosi për në vend menjëherë. Mund të provoni të porosisni për një datë dhe orë më vonë',
            },
            buttons: {
                order: {
                    book_order: 'Rezervo Tavolinë / Porosit Online',
                    order_online: 'Porosit Online',
                    book_table: 'Rezervo Tavolinë',
                    order: 'Porosi',
                    book: 'Rezervo',
                    cart: 'Shporta',
                    restart: 'Rifillo',
                    closed: 'Dyqani i Mbyllur',
                    not_accepting: 'Nuk Pranon Porosi',
                },
            },
        },
        modals: {
            auth: {
                login: 'Hyr',
                register: 'Regjistrohu',
                register_commence: 'Vazhdo',
                register_complete: 'Krijo Llogari',
                register_confirmation_sent: 'Një kod konfirmimi u dërgua në adresën tuaj të emailit. Shkruajeni më poshtë për të vazhduar',
                register_confirmation_resent: 'Kodi i konfirmimit u dërgua përsëri, kontrolloni spam-in ose rifilloni procesin',
                register_restart: 'Rifillo',
                register_resend_code: 'Ridërgo kodin',
                register_confirmation_code_subject: 'Kodi i Konfirmimit të Emailit',
                register_confirmation_code_email: 'Kodi juaj i konfirmimit të emailit është {{confirmation_code}} (Skadon pas 24 orësh)',
                login_placeholder: 'Email',
                password_placeholder: 'Fjalëkalimi',
                confirm_password_placeholder: 'Konfirmo Fjalëkalimin',
                confirmation_code_placeholder: 'Kodi i Konfirmimit të Emailit',
                accept_terms: 'Prano Kushtet & Rregullat',
                accept_terms_view: 'Shiko',
                login_facebook: 'Hyr me Facebook',
                login_google: 'Hyr me Google',
                benefits: 'Hyni ose krijoni një llogari për të ruajtur të gjitha porositë tuaja',
                logged_in: 'U kyçët me sukses',
                logged_out: 'U dolët',
                password_reset: {
                    init_button: 'Dërgo Email për Rivendosjen e Fjalëkalimit',
                    init_success: 'Lidhja për rivendosjen e fjalëkalimit u dërgua në emailin tuaj',
                    complete_button: 'Rivendos Fjalëkalimin',
                    complete_success: 'Fjalëkalimi u rivendos me sukses, hyni me fjalëkalimin e ri',
                    forgot_password_text: 'Keni harruar fjalëkalimin? ',
                    forgot_password_link: 'Rivendos fjalëkalimin',
                    remember_password_text: 'E mbani mend fjalëkalimin? ',
                    remember_password_link: 'Kthehu',
                    invalid_title: 'Rivendosja e Fjalëkalimit e Pavlefshme',
                    invalid_description: 'Kjo lidhje për rivendosjen e fjalëkalimit nuk është e vlefshme, kërkoni një të re',
                    invalid_link: 'Shko te Hyrja',
                    title: 'Rivendosja e Fjalëkalimit',
                    description: 'Shkruani një fjalëkalim të ri për llogarinë tuaj',
                },
                error_generic: 'Diçka shkoi keq, provoni përsëri ose na kontaktoni',
                error_accept_terms: 'Ju lutemi pranoni kushtet & rregullat',
                error_password_length: 'Minimumi 6 karaktere për fjalëkalimin',
                error_social: 'Diçka shkoi keq, provoni përsëri ose na kontaktoni',
                error_confirmation_code: 'Kod konfirmimi i pavlefshëm',
                error_invalid_code: 'Kod konfirmimi i pavlefshëm',
                error_exists: 'Përdoruesi ekziston tashmë',
                error_invalid_email_pass: 'Adresë emaili ose fjalëkalim i pavlefshëm',
                error_password_no_match: 'Fjalëkalimet nuk përputhen',
                error_user_not_found: 'Nuk ka përdorues me atë adresë emaili',
                error_invalid_email: 'Adresë emaili e pavlefshme',
                error_invalid_reset_token: 'Lidhje rivendosje e pavlefshme, kërkoni një tjetër',
            },
            booking: {
                form: {
                    name: 'Emri i Plotë',
                    email: 'Adresa e Emailit',
                    phone: 'Numri i Telefonit',
                    number_of_people: 'Numri i Personave',
                    number_of_people_max: 'Numri i Personave (Maks. {{max_people}})',
                    number_of_people_min: 'Numri i Personave (Min. {{min_people}})',
                    number_of_people_max_min: 'Numri i Personave (Midis {{min_people}} dhe {{max_people}})',
                    notes: 'Shënime / Kërkesa Speciale',
                    submit: 'Dërgo Kërkesën e Rezervimit',
                    email_optional: '(opsionale)',
                    date: 'Data',
                    duration: 'Kohëzgjatja',
                    seating: 'Oraret e lira',
                    number_of_guests: 'Numri i mysafirëve',
                    notes_placeholder: 'Alergjitë, rasti, preferenca e vendit',
                    reserving: 'Po rezervohet...',
                    reserve_table: 'Rezervo tavolinë',
                    please_choose_a_date_and_time: 'Zgjidhni një datë dhe orar.',
                    invalid_people: 'Numri i personave duhet të jetë midis {{min}} dhe {{max}}.',
                    party_size_max_fallback: 'maksimumi i lejuar',
                    loading_available_times: 'Po ngarkohen oraret e lira…',
                    select_a_date_to_see_available_times: 'Zgjidhni një datë për të parë oraret e lira.',
                    no_times_available_for_this_date: 'Nuk ka orare të lira për këtë datë. Zgjidhni një ditë tjetër.',
                    shift: 'Turni',
                    service_times: 'Orari i shërbimit',
                    new_shift: 'Turn i ri',
                    time: 'orar',
                    times: 'orare',
                    unavailable: 'I padisponueshëm',
                    available: 'I disponueshëm',
                    required_name: 'Shkruani emrin tuaj.',
                    required_phone: 'Shkruani numrin e telefonit.',
                    required_email: 'Shkruani adresën e emailit.',
                    invalid_email: 'Shkruani një adresë emaili të vlefshme.',
                    required_terms: 'Pranoni kushtet para se të rezervoni.',
                    reservation_is_unavailable: 'Rezervimi nuk është i disponueshëm.',
                    please_contact_the_restaurant_directly: 'Kontaktoni restorantin drejtpërdrejt.',
                    almost_done: 'Pothuajse gati',
                    your_details: 'Të dhënat tuaja',
                    tell_us_who_s_coming: 'Na tregoni kush vjen që të konfirmojmë rezervimin tuaj.',
                    book_your_table: 'Rezervoni tavolinën tuaj',
                    choose_a_time_that_works_for_you: 'Zgjidhni një orar që ju përshtatet.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Dërgoni kërkesën për rezervim dhe restoranti merret me të tjerat.',
                    select_date: 'Zgjidhni datën',
                    standard: 'Standard',
                    minutes: 'minuta',
                    next: 'Para →',
                    back: '← Mbrapa',
                    accept_terms: 'I pranoj termat dhe kushtet.',
                    info_1: 'Do të merrni një njoftim me email kur rezervimi juaj pranohet ose refuzohet',
                },
                errors: {
                    not_found: 'Rezervimi nuk ekziston. Mund të jetë fshirë',
                    generic: 'Diçka shkoi keq, rifreskoni faqen ose na kontaktoni',
                    something_went_wrong: 'Diçka shkoi keq',
                    accept_terms: 'Ju lutemi pranoni kushtet & rregullat',
                    required_phone: 'Ju lutemi shkruani numrin tuaj të telefonit',
                    required_email: 'Ju lutemi shkruani emailin tuaj',
                    required_zip: 'Ju lutemi shkruani kodin postar të faturimit',
                    required_name: 'Ju lutemi shkruani emrin tuaj',
                    invalid_email: 'Ju lutemi shkruani një adresë emaili të vlefshme',
                    invalid_phone: 'Ju lutemi shkruani një numër telefoni të vlefshëm',
                    invalid_people: 'Numër personash i pavlefshëm',
                    missing_custom_fields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara.',
                    booking_capacity_threshold: 'Jemi plot për këtë orar. Provoni një orar tjetër.',
                    slot_unavailable: 'Jemi plot për këtë numër personash. Provoni një orar tjetër.',
                    booking_date_paused: 'Rezervimet janë ndërprerë për këtë datë. Zgjidhni një ditë tjetër.',
                    invalid_table_assignment: 'Këto tavolina nuk e nxënë grupin tuaj. Zgjidhni një orar tjetër.',
                    exceeded_order_limit: 'Shumë kërkesa për rezervim. Provoni përsëri më vonë.',
                    validation_failed_recaptcha_v3: 'U zbulua trafik i pazakontë. Po përdorni VPN? Përfundoni verifikimin më sipër dhe provoni përsëri.',
                    validation_failed_recaptcha_v2: 'Rezervimi nuk mund të fillonte. Provoni përsëri ose përdorni një mënyrë tjetër. Nëse përdorni VPN, fikeni fillimisht.',
                    booking_already_exists: 'Ky rezervim është dërguar tashmë. Kontrolloni emailin ose hapni lidhjen e rezervimit.',
                    invalid_party_size: 'Zgjidhni një numër të vlefshëm personash.',
                    invalid_request: 'Kërkesë e pavlefshme. Rifreskoni faqen dhe provoni përsëri.',
                    table_booking_unavailable: 'Rezervimi i tavolinës nuk është i disponueshëm.',
                },
            },
            cart: {
                title: 'Shporta',
                proceed_to_checkout: 'Vazhdo te Pagesa',
                edit_dish: 'Ndrysho',
                remove_dish: 'Hiq',
                no_items_1: 'Nuk ka artikuj në shportë',
                no_items_2: 'Shtoni disa së pari për të vazhduar',
                free_delivery_notice: 'Dërgesë falas për porosi mbi {{value, currency}}',
                errors: {
                    min_order_promo: 'Vlera minimale e shportës {{value, currency}} kërkohet para se të aplikohet ky promocion',
                    min_order_delivery: 'Vlera minimale e shportës {{value, currency}} për dërgesë',
                },
                promo: {
                    heading: 'Kodi Promocional',
                    placeholder: 'Shkruani kodin promocional',
                    add: 'Shto Kodin',
                    title: 'Promocioni {{name}} u shtua në shportë',
                    fixed_discount: '{{value, currency}} Zbritje',
                    percent_discount: '{{value}}% Zbritje',
                    added_to_cart: 'Promocioni u shtua në shportë',
                    errors: {
                        not_found: 'Promocioni nuk u gjet',
                        disabled: 'Promocioni është i çaktivizuar',
                        not_available: 'Promocioni nuk është aktualisht i disponueshëm',
                        not_eligible: 'Nuk jeni të përshtatshëm për të aplikuar kodin promocional',
                        not_available_time: 'Promocioni nuk vlen për këtë orar',
                        logged_in_only: 'Duhet të jeni të kyçur për të përdorur këtë promocion',
                        already_used: 'E keni përdorur tashmë këtë promocion',
                        invalid: 'Ky promocion nuk është më i vlefshëm',
                        invalid_service: 'Ky promocion nuk vlen për shërbimin që keni zgjedhur',
                        later_only: 'Vlen vetëm për porosi paraprake',
                        now_only: 'Vlen vetëm për porosi të menjëhershme, jo paraprake',
                        generic: 'Ups... diçka shkoi keq dhe u regjistrua',
                        dishes_required_multi: 'Ky promocion do të aplikohet vetëm kur shtohen artikuj të caktuar në shportë',
                        dishes_required_single: 'Ky promocion do të aplikohet vetëm për \'{{dish}}\'',
                    },
                },
                tip: {
                    title: 'Bakshish Porosie',
                    placeholder: 'Shto bakshish porosie',
                },
            },
            free_items_promo: {
                title: 'Artikuj Falas',
                usage_confirmation: {
                    question: 'Jeni të përshtatshëm për artikuj falas. Dëshironi t\'i shihni dhe t\'i shtoni?',
                    cancellation: 'Jo, nuk dua artikuj falas',
                    acceptance: 'Po',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Zgjidhni {{number}} artikuj falas',
                    },
                    single: {
                        description: 'Zgjidhni një artikull falas',
                    },
                    confirm_button: 'Konfirmo',
                },
            },
            checkout: {
                title: 'Pagesa',
                subtitle: 'Konfirmoni detajet e porosisë',
                details: {
                    service: 'Shërbimi',
                    due: 'Afati',
                    due_now_asap: 'Tani / SA MË SHPEJT',
                    address: 'Adresa e Dërgesës',
                    total: 'Totali',
                    table: 'Tavolinë',
                    store_location: 'Adresa e Dyqanit',
                },
                customer: {
                    title: 'Klienti',
                    subtitle: 'Hyni për të ruajtur porosinë dhe detajet tuaja',
                    button: 'Hyr',
                    name: 'Emri i Plotë',
                    email: 'Email',
                    phone: 'Telefon',
                    phone_important: 'Telefon (E rëndësishme)',
                    notes: 'Shënime Porosie',
                    delivery_notes: 'Udhëzime Dërgese / Shënime Porosie',
                    uber_delivery_notes_too_long: 'Shënimet e dërgesës duhet të jenë {{max}} karaktere ose më pak për të bërë porosinë.',
                    uber_delivery_notes_near_limit: 'Keni arritur kufirin e {{max}} karaktereve. Shkurtoni shënimet për të bërë porosinë.',
                    optional: 'opsionale',
                },
                payment: {
                    title: 'Metoda e Pagesës',
                    qr_modal_help: 'Përdorni aplikacionin celular {{app}} për të skanuar QR-në dhe përfunduar pagesën për këtë porosi. Pasi pagesa të përfundojë në aplikacion, mund ta mbyllni këtë dritare QR. Mos e mbyllni nëse nuk keni përfunduar procesin e pagesës.',
                    switch_to_app_help: 'Duke shtypur butonin më poshtë, aplikacioni celular {{app}} do të hapet automatikisht për të përfunduar pagesën. Pasi pagesa të përfundojë, mund ta mbyllni këtë dritare. Mos e mbyllni nëse nuk keni përfunduar procesin e pagesës.',
                    open_app: 'Hap Aplikacionin {{app}}',
                    continue: 'Vazhdo',
                    continue_to_payment: 'Vazhdo te {{method}}',
                    back_to_cart: 'Kthehu te Shporta',
                },
                accept_terms: 'Prano Kushtet & Rregullat',
                accept_terms_view: 'Shiko',
                processing_order: 'Duke Përpunuar Porosinë',
                warning: {
                    different_payment_currency: 'Çmimet e dyqanit janë në {{store_currency}} por metoda e pagesës është në {{payment_currency}}',
                    closing_soon: 'Mbyllim së shpejti, porositë duhen bërë brenda {{value}} minutave',
                    closed: 'Na vjen keq, ky shërbim u mbyll dhe nuk pranohen porosi',
                    paused: 'Na vjen keq, ky shërbim është ndalur dhe aktualisht nuk pranohen porosi',
                    expired: 'Nuk mund ta përmbushim më porosinë tuaj në kohën e zgjedhur. Zgjidhni një datë ose orë më vonë',
                },
                errors: {
                    walletly_promo: 'Promocioni Walletly ka gabim, provoni një tjetër!',
                    stripe_generic: 'Gabim karte krediti, provoni përsëri ose zgjidhni metodë tjetër',
                    validation_failed: 'Kjo pagesë nuk mund të pranohet për momentin. Provoni më vonë ose zgjidhni metodë tjetër pagese.',
                    validation_failed_recaptcha_v3: 'U zbulua trafik i pazakontë. Po përdorni VPN? Plotësoni sfidën më sipër dhe provoni përsëri.',
                    validation_failed_recaptcha_v2: 'Nuk mundëm të fillonim pagesën. Provoni përsëri ose përdorni metodë tjetër. Nëse përdorni VPN, provoni ta fikni fillimisht.',
                    stripe_loading_fail: 'Gabim në ngarkimin e formularit të pagesës, provoni përsëri',
                    something_went_wrong: 'Diçka shkoi keq',
                    paypal_generic: 'Diçka shkoi keq me PayPal, provoni përsëri ose zgjidhni metodë tjetër pagese',
                    payment_fail: 'Pagesa dështoi, provoni përsëri ose zgjidhni metodë tjetër pagese',
                    payment_cancelled: 'Pagesa u anulua, provoni përsëri ose zgjidhni metodë tjetër pagese',
                    payment_error: 'Gabim në përpunimin e pagesës online, provoni përsëri ose zgjidhni metodë tjetër',
                    payment_declined: 'Metoda juaj e pagesës u refuzua',
                    card_declined: 'Karta juaj u refuzua dhe pagesa nuk mund të përpunohej',
                    store_closed: 'Dyqani është i mbyllur dhe nuk pranon më porosi',
                    accept_terms: 'Ju lutemi pranoni kushtet & rregullat',
                    required_payment: 'Ju lutemi zgjidhni një metodë pagese',
                    required_phone: 'Ju lutemi shkruani numrin tuaj të telefonit',
                    required_email: 'Ju lutemi shkruani emailin tuaj',
                    required_zip: 'Ju lutemi shkruani kodin postar të faturimit',
                    required_name: 'Ju lutemi shkruani emrin tuaj',
                    invalid_email: 'Ju lutemi shkruani një adresë emaili të vlefshme',
                    invalid_phone: 'Ju lutemi shkruani një numër telefoni të vlefshëm',
                    invalid_cc_number: 'Numri i kartës suaj të kreditit është i pavlefshëm',
                    invalid_order_amount: 'Shuma minimale e kërkuar për këtë metodë pagese',
                    retry_cc_number: 'Diçka shkoi keq, shkruani përsëri numrin e kartës dhe provoni përsëri',
                    closed: 'Dyqani është i mbyllur dhe nuk pranon porosi',
                    promo_login_required: 'Duhet të jeni të kyçur për të përdorur këtë promocion',
                    promo_used: 'E keni përdorur tashmë këtë promocion',
                    promo_by_payment_method_not_applicable: 'Promocioni nuk vlen për metodën e zgjedhur të pagesës.',
                    missing_custom_checkout_fields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara.',
                    delivery_unavailable: 'Shërbimi i dërgesës mund të mos jetë i disponueshëm për momentin. Konsideroni porosi me marrje.',
                    required_delivery_provider: 'Ju lutemi zgjidhni një shërbim dërgese.',
                    required_delivery_quotation: 'Vlerësimi i dërgesës ka skaduar.',
                    exceeded_order_limit: 'Po marrim shumë porosi për momentin. Zgjidhni një orë më vonë.',
                    exceeded_order_limit_later: 'Nuk mund ta përmbushim më porosinë tuaj në kohën e zgjedhur. Zgjidhni një datë ose orë më vonë',
                    dish_error: '{{items}} nuk janë më të disponueshëm. Rifreskoni ose hiqni nga shporta.',
                    promo_max_uses_exceeded: 'Ky kod promocional ka arritur kufirin e përdorimit dhe nuk është më i disponueshëm.',
                },
                button: {
                    continue: 'Vazhdo te Pagesa',
                    place_order: 'Bëj Porosinë',
                    update_order: 'Përditëso Porosinë',
                },
                delivery_estimation: {
                    title: 'Vlerësim Dërgese',
                    details: {
                        provider: 'Ofrues Dërgese',
                        estimated_fee: 'Tarifë e Vlerësuar',
                        estimated_total_fee: 'Totali i Tarifës së Dërgesës',
                        estimated_discount_fee: 'Zbritje Tarife Dërgese',
                        previous_estimated_fee: 'Tarifa e Mëparshme e Vlerësuar',
                        tips: 'Bakshishe',
                        estimated_delivery_time: 'Koha e Vlerësuar e Dërgesës',
                        uber_new_estimation: 'Kërko vlerësim të ri',
                        uber_new_estimation_success: 'U aplikua vlerësimi i ri i dërgesës Uber.',
                        uber_estimation_expired: 'Vlerësimi i dërgesës ka skaduar',
                        uber_price: 'Po mbajmë çmimin Uber',
                        uber_need_time: 'Më duhet më shumë kohë',
                        uber_delivery_notes_too_long: 'Shënimet e dërgesës duhet të jenë {{max}} karaktere ose më pak për të kërkuar dërgesë Uber.',
                        lalamove_price: 'Po mbajmë tarifën e dërgesës Lalamove',
                        lalamove_new_estimation_success: 'U aplikua vlerësimi i ri i dërgesës Lalamove.',
                        lalamove_estimation_expired: 'Vlerësimi i dërgesës ka skaduar',
                        lalamove_need_time: 'Më duhet më shumë kohë',
                        lalamove_new_estimation: 'Kërko vlerësim të ri',
                    },
                    quotation_error: 'Diçka shkoi keq duke llogaritur vlerësimin e dërgesës.',
                },
            },
            customer: {
                age_v: {
                    title: 'Verifikimi i Moshës',
                    required_for_items: 'Kërkohet për të porositur artikuj të caktuar',
                    min_age: 'Mosha minimale: {{age}} vjeç',
                    est_time: 'Koha e vlerësuar e verifikimit: {{time}} orë',
                    upload_description: 'Ngarkoni ID-në tuaj më poshtë për verifikim. Do të njoftoheni me email pas verifikimit. Ngarkoni deri në 2 imazhe me madhësi maksimale 2 MB secili',
                    pending_description_1: 'Faleminderit për dorëzimin e dokumenteve. Do të njoftoheni me email kur të miratoheni',
                    pending_description_2: 'Rifreskoni faqen për të përditësuar statusin e verifikimit. Koha e vlerësuar e verifikimit është {{time}} orë',
                    approved_description: 'Llogaria juaj u verifikua dhe mund të porosisni nga menu të kufizuara',
                    rejected_description: 'ID-ja juaj u refuzua. Nëse dëshironi të provoni përsëri, ringarkoni ID-në',
                    upload: 'Ngarko',
                    reupload: 'Ringarko Dokumentet',
                    go_back: 'Kthehu',
                    view_document: 'Shiko Dokumentin {{number}}',
                    status: {
                        unverified: 'I paverifikuar',
                        pending: 'Duke Pritur Miratimin',
                        approved: 'U Verifikua me Sukses',
                        rejected: 'Refuzuar',
                    },
                },
                headings: {
                    sessions: 'Seanca',
                    orders: 'Porosi',
                    spend: 'Shpenzime',
                    order_history: 'Historiku i Porosive',
                    loyalty: 'Besnikëri',
                    loyalty_points: 'Pikë Besnikërie',
                    added: 'Promocioni u shtua.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Zgjidhni një artikull para se të shpengoni!',
                    not_found: 'Promocioni nuk u gjet!',
                    already_exists: 'Promocioni ekziston tashmë!',
                    try_again: 'Nuk mund të aplikohet ky ofertë. Provoni përsëri!',
                },
            },
            custom_payment: {
                title: 'Formular Pagese {{name}}',
                description: 'Keni arritur formularin tonë të pagesës online. Plotësoni fushat më poshtë për të paguar. Nëse nuk shkruhet shuma, detajet ruhen por nuk do të tarifoheni.',
                disabled: 'Kjo faqe pagese online nuk është konfiguruar si duhet. Kontaktoni pronarin e faqes për ta rregulluar.',
                success: 'Pagesa juaj u përpunua me sukses dhe detajet u ruajtën. Faleminderit',
                back: 'Kthehu te Faqja Kryesore',
                fields: {
                    name: 'Emri i Plotë',
                    email: 'Adresa e Emailit',
                    reference: 'Ref. Pagese',
                    amount: 'Shuma ($)',
                    name_on_card: 'Emri në Kartë',
                    submit: 'Dërgo Pagesën',
                },
                warning: {
                    currency: 'Shënim: Shuma e pagesës në {{actual}}, jo {{default}}',
                },
                errors: {
                    generic: 'Diçka shkoi keq, provoni përsëri ose na kontaktoni',
                    stripe_generic: 'Gabim karte krediti, rifreskoni faqen dhe provoni përsëri',
                    payment_fail: 'Pagesa dështoi, provoni përsëri ose zgjidhni metodë tjetër pagese',
                    payment_cancelled: 'Pagesa u anulua, provoni përsëri ose zgjidhni metodë tjetër pagese',
                    payment_error: 'Gabim në përpunimin e pagesës online, provoni përsëri ose zgjidhni metodë tjetër',
                    payment_declined: 'Metoda juaj e pagesës u refuzua',
                    card_declined: 'Karta juaj u refuzua dhe pagesa nuk mund të përpunohej',
                    promo_max_uses_exceeded: 'Ky kod promocional ka arritur kufirin e përdorimit dhe nuk është më i disponueshëm.',
                },
            },
            dish: {
                add: 'Shto në Shportë',
                edit: 'Përditëso Artikullin',
                notes: 'Udhëzime speciale...',
                ingredients: {
                    title: 'Përbërësit',
                    uncheck_remove: 'Hiq shenjimin për të hequr',
                },
                ingredients_title: 'Përbërësit',
                combo: {
                    choose_dish: 'Zgjidhni një Artikull',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Zgjidhni një (E detyrueshme)',
                        select_one_optional: 'Zgjidhni një (Opsionale)',
                        select_between: 'Zgjidhni midis {{min}} - {{max}} (E detyrueshme)',
                        select_at_least: 'Zgjidhni të paktën {{qty}} (E detyrueshme)',
                        select_up_to: 'Zgjidhni deri në {{qty}} (Opsionale)',
                        select_multiple_optional: 'Zgjidhni disa (Opsionale)',
                        select_multiple: 'Zgjidhni disa (E detyrueshme)',
                        free_amount: '{{qty}} të Parët Falas / {{selected}} të Zgjedhur',
                    },
                    points: {
                        none_consumed: 'Mund të zgjidhni maksimumi {{maxFree}} opsione falas',
                        less_than_total_points: 'Mund të zgjidhni më shumë opsione falas',
                        greather_than_total_points: 'Mund të zgjidhni më shumë opsione me tarifë shtesë',
                    },
                },
                error: 'Korrigjoni opsionet e shënuara me të kuqe',
                added_to_cart: 'Artikulli u Shtua në Shportë',
            },
            map: {
                zone_fee: 'Tarifa e Dërgesës',
                view_in_google: 'Shiko në Google Maps',
            },
            portal_go_back: {
                title: 'Të kthehemi te Kërkimi i Restoranteve?',
                description: 'Çdo artikull në shportë do të humbasë',
                cancel: 'Anulo',
                proceed: 'Kthehu',
            },
            order: {
                config: {
                    services: {
                        title: 'Zgjidhni një Shërbim',
                        table_booking: 'Rezervo Tavolinë',
                    },
                    address_custom: {
                        input_placeholder: 'Shkruani adresën tuaj',
                    },
                    address: {
                        input_placeholder: 'Gjeni Adresën tuaj të Dërgesës',
                        extras_placeholder: 'Numri i njësisë, emri i ndërtesës, udhëzime dërgese, etj...',
                        search_placeholder: 'Kërkoni Adresën tuaj',
                        search_input_placeholder: 'Shkruani për të kërkuar',
                        no_address_found: 'Nuk u gjetën adresa. Provoni të shkruani më shumë se 5 karaktere',
                        not_found: 'Adresa e dërgesës nuk u gjet ose nuk është e vlefshme, provoni përsëri',
                        not_delivering: 'Aktualisht nuk dërgojmë në këtë adresë',
                        not_in_range: 'Adresa juaj nuk është brenda zonës së dyqanit tonë',
                        not_in_zone: 'Adresa juaj nuk është brenda një zone aktive dërgese',
                        no_number: 'Adresa juaj duhet të ketë numër rruge',
                        location_permission: 'Të lejohet kjo faqe të ketë qasje në vendndodhjen tuaj aktuale?',
                        location_permission_warning: 'Nuk mund të qasemi në vendndodhjen tuaj aktuale. Aktivizoni shërbimin e vendndodhjes në pajisje dhe shfletues. Ja disa referenca:',
                        pick_location: 'Zgjidhni Vendndodhjen tuaj',
                        pick_location_help_text: 'Tërhiqni shenjuesin për të zgjedhur vendndodhjen në hartë.',
                        use_current_location: 'Përdor Vendndodhjen Aktuale',
                        locate_on_map: 'Lokalizo në Hartë',
                    },
                    datetime: {
                        title: 'Kur dëshironi porosinë tuaj',
                        due_now: 'Tani',
                        due_later: 'Më vonë',
                        service_not_available: 'Na vjen keq, aktualisht nuk pranojmë porosi për {{service}}',
                        currently_closed: '{{service}} aktualisht i mbyllur por mund të porosisni për më vonë',
                        due_unavailable: 'I padisponueshëm',
                        due_closed: 'Mbyllur',
                        select_date: 'Zgjidhni Datën',
                        select_time: 'Zgjidhni Orën',
                        select_order_date: 'Zgjidhni Datën e Porosisë',
                        select_order_time: 'Zgjidhni Orën e Porosisë',
                        select_order_date_time: 'Zgjidhni Datën/Orën e Porosisë',
                        select_booking_date: 'Zgjidhni Datën e Rezervimit',
                        select_booking_time: 'Zgjidhni Orën e Rezervimit',
                        no_times_available: 'Nuk ka orare të disponueshme për zgjedhje',
                        date_today: '(Sot)',
                        date_closed: '(Mbyllur)',
                        date_bookings_paused: '(Rezervimet e ndërprera)',
                        time_slot_closed: 'Mbyllur',
                    },
                    number_of_people: {
                        placeholder: 'Numri i Personave',
                    },
                    table: {
                        select: 'Zgjidhni Tavolinën',
                        select_popup_title: 'Zgjidhni Tavolinën tuaj',
                        password: 'Fjalëkalimi i Tavolinës',
                        password_warning: 'Shkruani fjalëkalimin e tavolinës për të vazhduar',
                    },
                    warning: {
                        closed: 'Na vjen keq, jemi të mbyllur / nuk pranojmë porosi',
                        not_available: 'Na vjen keq, aktualisht nuk pranojmë porosi',
                    },
                    eta: {
                        delivery: `Koha e vlerësuar e dërgesës është rreth {{minutesToCustomer}} minuta`,
                        pickup: `Porosia do të jetë gati për rreth {{minutesToCustomer}} minuta`,
                    },
                    start_button: 'Fillo Porosinë',
                },
                history: {
                    invalid: 'Nuk jeni të përshtatshëm për ripriorit pasi disa artikuj janë ndryshuar ose nuk janë më të disponueshëm',
                },
                reorder: {
                    title: 'Riporitim i Shpejtë',
                    description: 'Porositni lehtësisht artikujt nga porositë tuaja të mëparshme',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Porosia nuk u gjet, rifreskoni faqen dhe provoni përsëri',
                    booking_not_found: 'Rezervimi nuk ekziston. Mund të jetë fshirë',
                    generic: 'Diçka shkoi keq, rifreskoni faqen ose na kontaktoni',
                },
                connection: {
                    connected: 'Përditësime në kohë reale',
                    connecting: 'Duke u lidhur me përditësimet në kohë reale',
                    disconnected: 'Përditësimet në kohë reale u shkëputën',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Paralajmërim',
                    title: 'Dil',
                    body: 'Dalja do të heqë çdo artikull që është shtuar në shportë',
                    cancel: 'Anulo',
                    proceed: 'Vazhdo',
                },
                order_restart: {
                    warning: 'Paralajmërim',
                    title: 'Ndrysho Detajet e Porosisë',
                    body: 'Ndryshimi i detajeve të porosisë do të heqë artikujt nga shporta pasi disa artikuj mund të mos jenë më të disponueshëm',
                    cancel: 'Anulo',
                    proceed: 'Vazhdo',
                },
                order_expired: {
                    subtitle: 'E rëndësishme',
                    title: 'Porosia u ndryshua për tani',
                    description: 'Koha e zgjedhur për porosinë tuaj është shumë afër. Prandaj porosia u ndryshua për tani / SA MË SHPEJT',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'E rëndësishme',
                    title: 'Afati i Porosisë Po Skadon Së Shpejti',
                    description: 'Porosia duhet bërë para {{time, timeFromTimestamp}} përndryshe nuk do të jetë më e vlefshme',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Anulo',
                    proceed: 'Vazhdo',
                },
            },
            card_payment_authentication: {
                title: 'Autentifikimi i Pagesës',
                note: 'Mbajeni këtë dritare hapur derisa të përfundoni procesin e autentifikimit nga banka juaj.',
            },
            maps: {
                cancel: 'Anulo',
                use_location: 'Përdor Vendndodhjen',
            },
            app_refresh: {
                refresh: 'Rifresko',
                title: 'Rifresko Dyqanin',
                description: 'Dyqani ynë u përditësua. Rifreskoni shfletuesin për të hyrë në versionin më të fundit. Pas rifreskimit, mund të duhet të rihapni shportën për të vazhduar me pagesën.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Mysafir',
                login: 'Hyr',
                login_signup: 'Hyr / Regjistrohu',
                logout: 'Dil',
            },
            menus: {
                info: {
                    no_menus: 'Aktualisht nuk ka menu të disponueshme',
                    restrictions: 'Kufizime Menuje',
                    not_available: 'Menu e Padisponueshme',
                    unavailable: {
                        times: 'Menu e padisponueshme, kërkesat e porosisë tuaj nuk përputhen më poshtë',
                        services: 'Menu e padisponueshme, kërkesat e porosisë tuaj nuk përputhen më poshtë',
                        hours: 'Menu e padisponueshme, orari i porosisë tuaj nuk është brenda orareve të disponueshme të kësaj menuje',
                        pre_order: 'Menu e padisponueshme, porosia juaj nuk përputhet me kërkesat e porosisë paraprake',
                        age: 'Menu e padisponueshme, duhet të jeni të kyçur me llogari të verifikuar për moshë për të porositur nga kjo menu',
                    },
                    services: {
                        title: 'Kërkesat e Porosisë',
                        pickup: 'Marrje',
                        delivery: 'Dërgesa',
                        dine_in: 'Në vend',
                    },
                    times: {
                        now: 'Pa porosi paraprake',
                        later: 'Vetëm porosi paraprake',
                    },
                    hours: {
                        title: 'Oraret e Disponueshme',
                    },
                    preorder: {
                        title: 'Kërkesat e Porosisë Paraprake',
                        days_in_advance: 'Duhet porositur {{days}} ditë paraprakisht',
                        cutoff_time: 'Koha e fundit e ditës së fundit në {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'I Kufizuar nga Mosha',
                        approved: 'Llogaria juaj është e verifikuar dhe mund të porosisni nga kjo menu',
                        rejected: 'Kërkohet verifikim moshe për të porositur. Krijoni llogari dhe ngarkoni ID-në',
                    },
                },
                search: {
                    title: 'Eksploro Artikujt e Menysë',
                    no_result: 'Asgjë nuk u gjet. Të provohet një term tjetër kërkimi?',
                    placeholder: 'Çfarë po kërkoni?',
                },
            },
            category: {
                restrictions: 'Kufizime Kategorie',
                not_available: 'Kategori e Padisponueshme',
                unavailable: {
                    services: 'Kategori e padisponueshme, kërkesat e porosisë tuaj nuk përputhen më poshtë',
                    hours: 'Kategori e padisponueshme, orari i porosisë tuaj nuk është brenda orareve të disponueshme të kësaj kategorie',
                },
            },
            info: {
                location: {
                    title: 'Vendndodhja',
                    view_map: 'Shiko Hartën',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Oraret e Hapjes',
                    title_special: 'Orare Speciale Hapjeje',
                },
                services: {
                    title: 'Shërbimet',
                    notes: 'Shënime',
                    delivery: {
                        ranges: 'Zonat e Dërgesës',
                        zones: 'Zonat e Dërgesës',
                        view_zones: 'Shiko Zonat në Hartë',
                        fee: 'Tarifa e Dërgesës',
                        fee_varies: 'Ndryshon, shfaqet në shportë',
                        min_order: 'Porosi Minimale',
                        no_min_order: 'Pa Porosi Minimale',
                        free_amount: 'Shuma për Dërgesë Falas',
                    },
                },
            },
            contact: {
                title: 'Na Kontaktoni',
                name: 'Emri',
                email: 'Email',
                phone: 'Numri i Telefonit',
                message: 'Shkruani mesazhin tuaj...',
                send: 'Dërgo Mesazhin',
                success: 'Mesazhi juaj u dërgua me sukses',
                error: 'Diçka shkoi keq, provoni përsëri ose më vonë',
            },
            footer: {
                powered_by: 'Mundësuar nga',
                terms_and_conditions: 'Kushtet & Rregullat',
                privacy: 'Politika e Privatësisë',
                cookie: 'Politika e Cookies',
            },
        },
        pages: {
            payment_completed: {
                title: 'Pagesa juaj u përpunua. Faleminderit për porosinë!',
                subtitle: 'Informacioni i porosisë u dërgua në adresën tuaj të emailit.',
                back_to_menu: 'Kthehu te Menuja',
                close_tab: 'Mbyll këtë skedë',
            },
            payment_failed: {
                title: 'Fatkeqësisht ndodhi një gabim gjatë përpunimit të pagesës.',
                subtitle: '',
                back_to_menu: 'Kthehu te Menuja',
                close_tab: 'Mbyll këtë skedë',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Faturë Rezervimi',
            details: {
                datetime: 'Rezervim Për',
                number_of_people: 'Nr. i Personave',
                placed: 'Vendosur',
                updated: 'Përditësuar Së Fundmi',
                notes: 'Shënime',
                name: 'Emri',
                email: 'Email',
                phone: 'Telefon',
                store_address: 'Adresa e Dyqanit',
            },
            status_update: {
                title: 'Rezervimi {{number}} u Përditësua',
                body: 'Statusi i rezervimit tuaj u përditësua në {{status}}',
            },
            email_common: {
                name: 'Emri: {{name}}',
                phone: 'Telefoni: {{number}}',
                number_of_people: 'Numri i Personave: {{number}}',
                date: 'Data: {{date}}',
                time: 'Ora: {{time}}',
                location: 'Vendndodhja e Dyqanit: {{name}}',
                notes: 'Shënime: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Rezervim i Ri Tavoline {{number}} nga {{name}}',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Kërkesë e Re Rezervimi Tavoline',
                title: 'Rezervim i Ri për {{name}}',
                subtitle: 'Numri i Rezervimit {{number}}',
                description_confirmed: 'Rezervimi u konfirmua automatikisht. Mund ta anuloni përmes panelit të administrimit dhe klienti do të njoftohet me email',
                description_unconfirmed: 'Ju lutemi konfirmoni ose anuloni rezervimin përmes panelit të administrimit',
                url_pre_text: 'Shikoni dhe përditësoni në',
            },
            email_new_booking_customer: {
                subject: 'Kërkesë Rezervimi Tavoline',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Kërkesë e Re Rezervimi Tavoline',
                title: 'Faleminderit për Rezervimin',
                subtitle: 'Numri i Rezervimit {{number}}',
                description: '<b>Do të merrni një email tjetër kur rezervimi juaj të konfirmohet ose refuzohet.</b><br>Na kontaktoni për ndryshime në rezervimin tuaj. Detajet e rezervimit tuaj janë si më poshtë:',
                url_pre_text: 'Mund ta shikoni faturën e rezervimit në kohë reale në',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Rezervimi i Tavolinës u Konfirmua',
                subject_unconfirmed: 'Rezervimi i Tavolinës u Anulua',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Kërkesë Rezervimi Tavoline',
                title_confirmed: 'Rezervimi u Konfirmua',
                title_unconfirmed: 'Rezervimi u Anulua',
                subtitle: 'Numri i Rezervimit {{number}}',
                description_confirmed: 'Mezi presim t\'ju shohim. Na kontaktoni për të kërkuar ndryshime në rezervimin tuaj',
                description_unconfirmed: 'Na vjen keq t\'ju informojmë se kërkesa juaj e rezervimit nuk mund të pranohej. Kërkojmë ndjesë për shqetësimin. Na kontaktoni nëse keni pyetje',
                url_pre_text: 'Mund ta shikoni faturën e rezervimit në kohë reale në',
            },
            email_status_update_customer: {
                subject: 'Rezervim #{{number}} – {{subjectLabel}}',
                body: 'Rezervimi juaj #{{number}} te {{store}} tani është {{status}}.',
            },
            errors: {},
            status_warning: 'Përditësoni statusin e këtij rezervimi në panelin e administrimit në faqen e rezervimeve',
        },
    },
    email_delayed_order: {
        subject: 'Porosi #{{number}} – {{subjectLabel}}',
        header: 'Ora e përditësuar e gatishmërisë',
        title: 'Ora e përditësuar e gatishmërisë',
        order_number: 'Numri i Porosisë: {{number}}',
        description: 'Porosia juaj do të jetë gati në {{time}}.',
        order_time_updated_to: 'Ora e porosisë suaj është përditësuar.',
        powered_by: 'Mundësuar nga {{name}}',
        button_text: 'Ndiq Porosinë',
        subject_label: 'Ora e përditësuar e gatishmërisë',
        subject_label_delivery: 'Ora e përditësuar e dorëzimit',
        body_ready: 'Porosia juaj do të jetë gati në {{time}}.',
        body_delivery: 'Porosia juaj do të dorëzohet në {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Koha e Vler. e Gatishmërisë',
            est_driver_pickup_time: 'Koha e Vler. e Marrjes nga Shoferi',
            est_delivery_time: 'Koha e Vler. e Dërgesës',
            tab_details: 'Detaje',
            tab_dishes: 'Artikuj',
            future_order: 'Porosi e Ardhshme',
            reprint: 'RIPRINTIM',
            details: {
                order_no: 'Nr. Porosisë',
                status: 'Statusi',
                placed: 'Vendosur',
                due: 'Afati',
                due_asap: 'Tani / SA MË SHPEJT',
                last_updated: 'Përditësuar Së Fundmi',
                total: 'Totali',
                type: 'Lloji',
                origin: 'Origjina',
                table: 'Tavolinë',
                number_of_people: 'Numri i Personave',
                payment_method: 'Metoda e Pagesës',
                payment_status: 'Statusi i Pagesës',
                payment_currency: 'Monedha e Pagesës',
                notes: 'Shënime',
                name: 'Emri',
                email: 'Email',
                phone: 'Telefon',
                distance: 'Distanca',
                driving_time: 'Koha e Ngarjes',
                delivery_zone: 'Zona',
                delivery_address: 'Adresa e Dërgesës',
                delivery_provider: 'Ofrues Dërgese',
                delivery_tracking: 'Ndjekja e Dërgesës',
                delivery_return_tracking: 'Ndiq Kthimin',
                delivery_tracking_link: 'Ndiq Porosinë',
                tookan_status: 'Statusi Tookan',
                tookan_status_failed_book: 'Dështoi rezervimi i dërgesës',
                tookan_status_failed_update: 'Dështoi përditësimi i rezervimit',
                tookan_status_success: 'Rezervuar për dërgesë',
                store_address: 'Adresa e Dyqanit',
                destination: 'Destinacioni',
                estimated_arrival_time: 'Koha e Vlerësuar e Mbërritjes',
                delivery_status: 'Statusi',
                delivery_track_your_order: 'Ndiq Porosinë tuaj',
                delivery_text: 'Dërgesë',
                arrival_date: 'Data e Mbërritjes',
            },
            dishes: {
                headings: {
                    quantity: 'Sasi',
                    item: 'Artikull',
                    price: 'Çmimi',
                },
                notes: 'Shënime',
                remove_ingredients: 'Hiq Përbërësit',
            },
            status_update: {
                title: 'Porosia {{number}} u Përditësua',
                body: 'Statusi i porosisë tuaj u përditësua në {{status}}',
            },
            wait_time_update: {
                title: 'Porosia {{number}} u Përditësua',
                body: 'Koha e afatit të porosisë tuaj u përditësua',
            },
            delivery_update: {
                title: 'Porosia {{number}} u Përditësua',
                body: 'Porosia juaj u rezervua për dërgesë. Shihni lidhjen e ndjekjes në kohë reale',
            },
            payment_status_update: {
                title: 'Porosia {{number}} u Përditësua',
                body: 'Statusi i pagesës së porosisë tuaj u përditësua.',
            },
            email_new_order_restaurant: {
                subject: 'Porosi e Re ({{number}}) - {{name}}',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Njoftim Porosie të Re',
                title: 'Porosi e Re në {{name}}',
                subtitle: 'Numri i Porosisë {{number}}',
                description: 'Shikoni detajet dhe përditësimet përmes panelit tuaj të administrimit',
                button_text: 'Ndiq Porosinë',
                track_delivery_button_text: 'Ndiq Dërgesën',
            },
            email_new_order_customer: {
                subject: 'Faturë Porosie ({{number}})',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Njoftim Porosie të Re',
                title: 'Porosi e Re në {{name}}',
                subtitle: 'Numri i Porosisë {{number}}',
                description: 'Shikoni detajet dhe përditësimet përmes faturës suaj online në kohë reale',
                button_text: 'Ndiq Porosinë',
                track_delivery_button_text: 'Ndiq Dërgesën',
            },
            email_order_completed_by_customer: {
                subject: 'Porosia ({{number}}) u Përfundua nga Klienti',
                powered_by: 'Mundësuar nga {{name}}',
                overview: 'Njoftim Përfundimi Porosie',
                title: 'Porosia u Përfundua në {{name}}',
                subtitle: 'Numri i Porosisë {{number}}',
                description: 'Shikoni detajet dhe përditësimet e porosisë përmes panelit ose faturës në',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) përf. në çmim',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Tarifa e Dërgesës',
            delivery_fee_offset: 'Zbritje Tarife Dërgese',
            delivery_fee_total: 'Totali i Tarifës së Dërgesës',
            promo: 'Zbritje: {{name}} ({{value, currency}} + {{percent}}% Off)',
            promo_percent: 'Zbritje: {{name}} ({{percent}}%)',
            promo_fixed: 'Zbritje: {{name}}',
            promo_none: 'Zbritje: {{name}}',
            cart: 'Shporta',
            tip: 'Bakshish porosie',
            total: 'Totali',
        },
        status: {
            unconfirmed: 'E Pakonfirmuar',
            awaiting_payment: 'Duke Pritur Pagesën',
            confirmed: 'E Konfirmuar',
            ready: 'Gati',
            on_route: 'Në Rrugë',
            complete: 'E Përfunduar',
            cancelled: 'E Anuluar',
            seated: 'Ulur',
        },
        searching: {
            lalamove_search_placeholder: 'Kërko porosi sipas ID-së së dërgesës Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'I padisponueshëm',
                },
            },
            dish: {
                no_stock: 'Jashtë Stokut',
                not_available: 'Nuk Disponohet',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Kodi i Konfirmimit të Emailit',
            register_confirmation_code_email: 'Kodi juaj i konfirmimit të emailit është {{confirmation_code}} (Skadon pas 24 orësh)',
            register_confirmation_code_email_onbehalf: 'Kodi juaj i konfirmimit të emailit është {{confirmation_code}} (Skadon pas 24 orësh). Ky është për adresën e emailit {{email}}.',
        },
    },
};
//# sourceMappingURL=sq.js.map